﻿export class InlineMessage {
    private messageElement: HTMLElement;
    private dialogElement: HTMLElement;
    private scrollableContainer: HTMLElement;
    private isShown: boolean = false;

    constructor(messageRef: HTMLElement, dialogRef: HTMLElement) {
        this.messageElement = messageRef;
        this.dialogElement = dialogRef;

        this.scrollableContainer = this.findScrollableContainer(this.messageElement);
    }

    public ShowDialog(): void {
        if (this.isShown === true) {
            return;
        }

        if (this.dialogElement.classList.contains("inline-message__content")) {
            this.dialogElement.classList.remove('inline-message__content');
            this.dialogElement.classList.add('inline-message__content--expanded');
        }

        this.updateDialogPosition();

        this.isShown = true;
    }

    public CloseDialog(): void {
        if (this.isShown === false) {
            return;
        }

        if (this.dialogElement.classList.contains("inline-message__content--expanded")) {
            this.dialogElement.classList.remove('inline-message__content--expanded');
            this.dialogElement.classList.add('inline-message__content');
        }

        this.isShown = false;
    }

    private findScrollableContainer(element: HTMLElement): HTMLElement | null {
        let parent = element.parentElement;

        while (parent) {
            const overflowY = window.getComputedStyle(parent).overflowY;
            if (overflowY === 'scroll' || overflowY === 'auto') {
                return parent;
            }
            parent = parent.parentElement;
        }
        return null; // Default to null if no scrollable parent is found
    }

    private updateDialogPosition(): void {
        const padding = 16;
        const messageRect = this.messageElement.getBoundingClientRect();
        const containerRect = this.scrollableContainer.getBoundingClientRect(); // Get the container's position

        // Get the scroll position of the container
        const scrollTop = this.scrollableContainer.scrollTop;

        // Calculate the available space for the dialog
        const viewportWidth = window.innerWidth;
        const availableSpace = viewportWidth - padding * 2;

        // Set max width for the dialog
        this.dialogElement.style.maxWidth = availableSpace + "px";
        const dialogRect = this.dialogElement.getBoundingClientRect();

        // Initial position - centered below the message
        let dialogLeft = messageRect.left + messageRect.width / 2 - dialogRect.width / 2;

        // Ensure the dialog doesn't overflow on the left or right
        if (dialogLeft < padding) {
            dialogLeft = padding;
        }

        if (dialogLeft + dialogRect.width > viewportWidth - padding) {
            dialogLeft = viewportWidth - padding - dialogRect.width;
        }

        // Apply the positioning relative to the scrollable container
        this.dialogElement.style.left = dialogLeft + "px";

        // Adjust the top position by taking into account the container's scroll position
        this.dialogElement.style.top = (messageRect.bottom - containerRect.top + scrollTop) + "px";
    }
}

window['InitInlineMessage'] = function (messageRef: HTMLElement, dialogRef: HTMLElement) {
    return new InlineMessage(messageRef, dialogRef);
};